package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_02_22_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes wake and prepare for another long day of oppressive heat under the desert sun.  When Falorn uses his magic to create water, Tuesday shapes that water into a large block of ice, so the heroes and Flower can enjoy cool water throughout the day.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes see a package on the path and move closer to investigate. The ground shakes and once again the heroes face gargantuan scorpions, but this time Bigglesworth shows more restraint, having nearly died on Newgrowth 69 after charging way ahead of his companions and getting surrounded. The heroes kill the scorpions and harvest chitin and meat. Falorn opens the package and finds some blankets.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes continue on. Annette scries Alexander again. He appears to be just south of Fool’s Oasis, directly east of the heroes’ current location. During the night, Goram and Falorn hear large wings flapping during their watch and low growl — perhaps there is another dragon in the area.")
    }
}
